{
  "breadcrumbAriaLabel": "Đường dẫn",
  "homeAriaLabel": "Trang chủ",
  "mainNavAriaLabel": "Điều hướng chính",
  "closeSidebarAriaLabel": "Đóng thanh bên",
  "collapse": "Thu gọn",
  "help": "Trợ giúp",
  "settings": "Cài đặt",
  "myProfile": "Hồ sơ của tôi",
  "groups": {
    "clinical": "Lâm sàng",
    "worklists": "Danh sách công việc",
    "documentation": "Hồ sơ bệnh án",
    "orders": "Y lệnh",
    "medications": "Thuốc",
    "scheduling": "Lịch hẹn",
    "billing": "Thanh toán",
    "analytics": "Phân tích",
    "organization": "Tổ chức",
    "security": "Bảo mật",
    "accessReviews": "Access Reviews",
    "integrations": "Tích hợp",
    "system": "Hệ thống",
    "licensing": "Giấy phép"
  },
  "dashboard": "Bảng điều khiển",
  "patients": "Bệnh nhân",
  "patientSearch": "Tìm bệnh nhân",
  "myPatients": "Bệnh nhân của tôi",
  "censusBedBoard": "Danh sách nội trú / Bảng giường",
  "providerDirectory": "Danh bạ bác sĩ",
  "providerCoverage": "Phân ca trực bác sĩ",
  "patientMerge": "Ghép hồ sơ bệnh nhân",
  "inbox": "Hộp thư đến",
  "pendingResults": "Kết quả chờ duyệt",
  "criticalResults": "Kết quả nguy kịch",
  "unsignedNotes": "Ghi chú chưa ký",
  "cosignQueue": "Hàng đợi đồng ký",
  "noteTemplates": "Mẫu ghi chú",
  "smartPhrases": "Cụm từ thông minh",
  "orderCatalog": "Danh mục y lệnh",
  "orderSets": "Bộ y lệnh",
  "encounters": "Lượt khám",
  "orders": "Y lệnh",
  "results": "Kết quả",
  "medications": "Thuốc",
  "notes": "Ghi chú lâm sàng",
  "medicationWorklist": "Medication Worklist",
  "formulary": "Danh mục thuốc",
  "pharmacistQueue": "Hàng đợi dược sĩ",
  "appointments": "Lịch hẹn",
  "scheduleManagement": "Quản lý lịch",
  "waitlist": "Danh sách chờ",
  "charges": "Khoản phí",
  "claims": "Yêu cầu thanh toán",
  "payments": "Thanh toán",
  "accounts": "Tài khoản",
  "statements": "Sao kê",
  "denials": "Từ chối thanh toán",
  "analyticsDashboard": "Bảng điều khiển",
  "reports": "Báo cáo",
  "qualityMeasures": "Chỉ số chất lượng",
  "healthSystems": "Hệ thống y tế",
  "facilities": "Cơ sở y tế",
  "locations": "Địa điểm",
  "clinicalTaxonomy": "Phân loại lâm sàng",
  "serviceLocation": "Dịch vụ ↔ Địa điểm",
  "providers": "Nhân viên y tế",
  "users": "Người dùng",
  "roles": "Vai trò",
  "accessMatrix": "Ma trận quyền",
  "integrations": "Tích hợp",
  "thirdPartyApps": "Ứng dụng bên thứ ba",
  "audit": "Kiểm toán",
  "system": "Hệ thống",
  "cdsRules": "Quy tắc CDS",
  "escalationRules": "Escalation Rules",
  "segments": {
    "search": "Tìm kiếm",
    "register": "Đăng ký",
    "demographics": "Thông tin nhân khẩu",
    "census": "Nội trú",
    "discharge": "Xuất viện",
    "catalog": "Danh mục",
    "sets": "Bộ y lệnh",
    "pending": "Chờ xử lý",
    "critical": "Nguy kịch",
    "reconciliation": "Đối chiếu thuốc",
    "worklist": "Danh sách công việc",
    "templates": "Mẫu",
    "smartPhrases": "Cụm từ thông minh",
    "schedule": "Quản lý lịch",
    "quality": "Chỉ số chất lượng",
    "administration": "Quản trị",
    "auditLog": "Nhật ký kiểm toán",
    "allergies": "Dị ứng",
    "problems": "Danh sách vấn đề",
    "immunizations": "Tiêm chủng",
    "insurance": "Bảo hiểm"
  },
  "handoffs": "Bàn giao",
  "duplicateReview": "Xem xét trùng lặp",
  "sso": "SSO & Directories",
  "userGroups": "User Groups",
  "fileKey": "File key",
  "ordersWorklist": "Danh sách công việc y lệnh"
}
